import React from 'react';
import styled from 'styled-components';
import { SelectPicker } from 'rsuite';
import { FormGroup } from '../../../widgets/FormElements';

export const StyledFormGroup = styled(FormGroup)`
  padding: 8px;
  position: relative;
  border-radius: 5px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  &.opaq {
    opacity: 0.6;
  }
`;

export const CustomFormControl = styled(({ className, ...props }) => (
  <div {...props} className={`${className} rs-form-control-wrapper`} />
))`
  display: inline-block;
`;

export const LimitRulesSelectPicker = styled(SelectPicker)`
  &.rs-picker-has-value {
    .rs-btn.rs-btn-default {
      padding-left: 4px;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
`;
